import { render } from "./email-campaigns.vue?vue&type=template&id=f6600c36"
import script from "./email-campaigns.vue?vue&type=script&lang=js"
export * from "./email-campaigns.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__